import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_34720aeb: FaireBrandEntity = {
  token: "b_34720aeb",
  type: "brand",
  name: "Richie Designs",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/4b06cb3f22e5669706cafb007e896a3de3941e7bc41e23726c8721d61b62d5a6/1562797228.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a60f1f132a2b9d6381c2faf93bea92d6ed2eda8885650e6f8b5f63f46f71d27a.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/4b06cb3f22e5669706cafb007e896a3de3941e7bc41e23726c8721d61b62d5a6/1562797228.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a60f1f132a2b9d6381c2faf93bea92d6ed2eda8885650e6f8b5f63f46f71d27a.jpeg",
  location: "Long Beach, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 55,
  isInsider: true,
  description:
    "Richie Designs is a boutique design and letterpress studio located in Long Beach, Ca.  Owner, Richele Silva, is a print and greeting card lover and the woman behind the curtain.\n\nShe often describes her printing career as a hobby gone awry, when she began printing classes during her first career in advertising. We know she really just likes to hang out with Stella, her Vandercook Proofing Press making really cool stuff. We only use 100% tree free, cotton paper. The cotton is left over from the garment industry which means no additional water or growing is required. It’s fluffy and amazing to touch, almost like fabric. \n\nOur greetings serve multiple purposes, encouragement to a friend, a quirky take on something funny. Richele designs for needs that come up naturally, often turning real life conversations into her greeting sentiments.\n\nRichele has been featured on notable sites such as Rachel Zoe’s, The Zoe Report, Brides Magazine, Cool Hunting and Oh So Beautiful Paper.\n\nRichele lives with her non-artsy husband in Belmont Heights, Long Beach. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:45.970Z",
    importedBy: "entity-db-cli",
  },
};
